// initial state
const baseName = '/admin/api/analysis'

const analysisSimpleInfo = baseName + '/simpleInfo'
const analysisCountDataTotal= baseName + '/orderMoneyCountDataTotal'
const analysisHotDataTotal= baseName + '/deviceHotDataTotal'
const a = Object.assign({analysisSimpleInfo,analysisCountDataTotal,analysisHotDataTotal})
export default a